import { useMemo } from 'react';
import { SlideshowPreview } from 'dash-ui';
import {
  GetPropertyByIdQuery,
  useGetSlideshowMediaByPropertyQuery,
  useObserveMediaChangesSubscription,
} from 'gql/generated.graphql';

function SlideShowPreview({
  property,
}: {
  property: GetPropertyByIdQuery['getPropertyById'];
}) {
  const filter = { propertyId: property._id, ignoreHierarchy: true };
  const { data, loading, refetch } = useGetSlideshowMediaByPropertyQuery({
    variables: { propertyId: property._id },
  });

  useObserveMediaChangesSubscription({
    variables: { filter },
    onData() {
      refetch();
    },
  });

  const mediaFiles = useMemo(
    () => data?.getSlideshowMediaByProperty || [],
    [data]
  );

  const files = useMemo(
    () =>
      mediaFiles.map((item) => {
        const [file] = item.files;

        return {
          _id: item._id,
          name: file?.name,
          publicUrl: file?.publicUrl,
          s3Key: file?.s3Key,
          type: file?.type,
          thumbnailFileUrl: file?.thumbnailFile?.publicUrl,
        };
      }),
    [mediaFiles]
  );

  return (
    <SlideshowPreview
      w="100%"
      files={files}
      loading={loading}
      totalCount={files.length}
      mainFileId={property.mainPropertyMediaId}
    />
  );
}

export default SlideShowPreview;
